import getField from '@form/formGenerator'

export const missionSubjectSaveUrl = `${import.meta.env.VITE_API_URL}/api/mission-subjects`

export const missionSubjectFormObject = {
  id: null,
  subject: null
}

export const missionSubjectFormFields = (missionSubjectObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'subject',
      label: t('labels.subject'),
      value: missionSubjectObject.subject,
      key: 'missionSubjectObject-subject',
      cssClass: 'column is-12'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'missionSubjectObject-form',
      isLoading
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}